import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../UserContext";
import SubscriptionPlans from "./index";
import { FaTimes } from "react-icons/fa";
import "./SubscriptionGate.css"; // Note the new CSS file name

const SubscriptionGate = () => {
  const { t } = useTranslation();
  // Get the state setter from the context
  const { setShowSubscriptionPlans } = useContext(UserContext);

  // This function now just closes the modal by setting state to false
  const handleClose = () => {
    setShowSubscriptionPlans(false);
  };

  return (
    // The overlay div that darkens the background
    <div className="gate-modal-overlay" onClick={handleClose}>
      {/* The modal content itself, stopPropagation prevents clicks inside from closing it */}
      <div className="gate-modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={handleClose}
          className="close-gate-button"
          aria-label={t("Close")}
          title={t("Close")}
        >
          <FaTimes />
        </button>

        {/* We render the existing SubscriptionPlans component inside */}
        <SubscriptionPlans />
      </div>
    </div>
  );
};

export default SubscriptionGate;
